import React, { useState, useEffect } from 'react';
import { Card, Form, Input, Button, Typography, message, Alert, Radio } from 'antd';
import Cookies from 'js-cookie';
import { paymentAPI } from '../api/payment';

const { Title, Paragraph } = Typography;

const GATEWAY_LABELS = {
  zarinpal: '💳 کارت بانکی (تومان) — زرین‌پال',
  zibal: '💳 کارت بانکی (تومان) — زیبال',
  oxapay: '🪙 ارز دیجیتال (کریپتو) — OxaPay'
};

/**
 * GiftInvitation.jsx
 * خرید «بسته کامل ورود» برای شخص دیگری (هدیه) — طبق فلوچارت: حساب خودِ خریدار
 * دست‌نخورده می‌ماند، فقط یک کد دعوت قابل‌انتقال برای گیرنده ساخته می‌شود که
 * او با شماره‌ی خودش (از طریق صفحه پیام محرمانه) آن را claim می‌کند.
 */
export default function GiftInvitation() {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [availableGateways, setAvailableGateways] = useState(null);
  const token = Cookies.get('token');

  useEffect(() => {
    paymentAPI.getAvailableGateways()
      .then((res) => { if (res.data?.success) setAvailableGateways(res.data.gateways || []); })
      .catch(() => setAvailableGateways([]));
  }, []);

  const showGatewayChoice = Array.isArray(availableGateways) && availableGateways.length > 1;

  const handleSubmit = async (values) => {
    if (!token) {
      message.error('برای خرید هدیه اول وارد حساب کاربری‌ات شو.');
      return;
    }
    setLoading(true);
    try {
      const res = await paymentAPI.requestGiftPackagePayment(values);
      if (res.data.success && res.data.paymentUrl) {
        window.location.href = res.data.paymentUrl;
      } else {
        message.error(res.data.message || res.data.error || 'خطا در ایجاد پرداخت');
      }
    } catch (error) {
      message.error(error.response?.data?.message || 'خطا در اتصال به سرور');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ maxWidth: 520, margin: '40px auto', padding: '0 16px' }}>
      <Card>
        <Title level={3}>🎁 هدیه‌ی ورود به هاگوارتز</Title>
        <Paragraph type="secondary">
          یک «بسته کامل ورود» (دعوت‌نامه رسمی + عبور تضمینی از سکو + بلیت قطار) برای یکی از دوستانت بخر.
          حساب خودت هیچ تغییری نمی‌کند — فقط یک کد دعوت اختصاصی برای او ساخته می‌شود.
        </Paragraph>
        {!token && (
          <Alert type="warning" showIcon style={{ marginBottom: 16 }} message="برای ادامه ابتدا وارد حساب خودت شو." />
        )}
        <Form form={form} layout="vertical" onFinish={handleSubmit}>
          <Form.Item name="recipientFirstName" label="نام گیرنده" rules={[{ required: true, message: 'نام الزامی است' }]}>
            <Input placeholder="مثال: هری" />
          </Form.Item>
          <Form.Item name="recipientLastName" label="نام خانوادگی گیرنده" rules={[{ required: true, message: 'نام خانوادگی الزامی است' }]}>
            <Input placeholder="مثال: پاتر" />
          </Form.Item>
          <Form.Item
            name="recipientPhone"
            label="شماره تماس گیرنده (اختیاری)"
            extra="اگر خالی بماند، اولین کسی که لینک را باز کند و کد پیامکی بگیرد، صاحب هدیه می‌شود."
          >
            <Input placeholder="۰۹۱۲۳۴۵۶۷۸۹" dir="ltr" />
          </Form.Item>
          <Form.Item name="addressLine1" label="آدرس گیرنده - خط ۱ (اختیاری)">
            <Input />
          </Form.Item>
          <Form.Item name="addressLine2" label="آدرس گیرنده - خط ۲ (اختیاری)">
            <Input />
          </Form.Item>
          <Form.Item name="addressLine3" label="آدرس گیرنده - خط ۳ (اختیاری)">
            <Input />
          </Form.Item>

          {showGatewayChoice && (
            <Form.Item
              name="gateway"
              label="روش پرداخت"
              initialValue={availableGateways[0]}
              rules={[{ required: true, message: 'روش پرداخت را انتخاب کن' }]}
            >
              <Radio.Group optionType="button" buttonStyle="solid" style={{ width: '100%', display: 'flex' }}>
                {availableGateways.map((gw) => (
                  <Radio.Button key={gw} value={gw} style={{ flex: 1, textAlign: 'center' }}>
                    {GATEWAY_LABELS[gw] || gw}
                  </Radio.Button>
                ))}
              </Radio.Group>
            </Form.Item>
          )}

          <Button type="primary" htmlType="submit" block size="large" loading={loading} disabled={!token}>
            پرداخت و ارسال هدیه — ۵۰۰ هزار تومان
          </Button>
        </Form>
      </Card>
    </div>
  );
}
